export default "__VITE_ASSET__CSpU2Vi___"